"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PROJECT_STATUS = exports.CURRENCY = exports.PROJECT_EVENTS = exports.PROJECT_CATEGORY = void 0;
var PROJECT_CATEGORY;
(function (PROJECT_CATEGORY) {
    PROJECT_CATEGORY["KITCHEN"] = "KITCHEN";
    PROJECT_CATEGORY["BATHROOM"] = "BATHROOM";
    PROJECT_CATEGORY["BEDROOM_STORAGE"] = "BEDROOM_STORAGE";
})(PROJECT_CATEGORY = exports.PROJECT_CATEGORY || (exports.PROJECT_CATEGORY = {}));
var PROJECT_EVENTS;
(function (PROJECT_EVENTS) {
    PROJECT_EVENTS["PROJECT_CREATED"] = "PROJECT_CREATED";
    PROJECT_EVENTS["PROJECT_UPDATED"] = "PROJECT_UPDATED";
    PROJECT_EVENTS["PROJECT_CANCELLED"] = "PROJECT_CANCELLED";
    PROJECT_EVENTS["DESIGN_CREATED"] = "DESIGN_CREATED";
    PROJECT_EVENTS["DESIGN_SAVED"] = "DESIGN_SAVED";
    PROJECT_EVENTS["DESIGN_QUOTE_CREATED"] = "DESIGN_QUOTE_CREATED";
    PROJECT_EVENTS["DESIGN_DUPLICATED"] = "DESIGN_DUPLICATED";
    PROJECT_EVENTS["OWNER_CHANGES"] = "OWNER_CHANGES";
    PROJECT_EVENTS["PROJECT_SOLD"] = "PROJECT_SOLD";
    PROJECT_EVENTS["STATUS_CHANGED"] = "STATUS_CHANGED";
})(PROJECT_EVENTS = exports.PROJECT_EVENTS || (exports.PROJECT_EVENTS = {}));
var CURRENCY;
(function (CURRENCY) {
    CURRENCY["GBP"] = "GBP";
    CURRENCY["EUR"] = "EUR";
})(CURRENCY = exports.CURRENCY || (exports.CURRENCY = {}));
var PROJECT_STATUS;
(function (PROJECT_STATUS) {
    PROJECT_STATUS["INPROGRESS"] = "INPROGRESS";
    PROJECT_STATUS["QUOTED"] = "QUOTED";
    PROJECT_STATUS["SOLD"] = "SOLD";
    PROJECT_STATUS["INACTIVE"] = "INACTIVE";
    PROJECT_STATUS["LOST"] = "LOST";
    PROJECT_STATUS["ARCHIVED"] = "ARCHIVED";
    PROJECT_STATUS["ON_HOLD"] = "ON_HOLD";
})(PROJECT_STATUS = exports.PROJECT_STATUS || (exports.PROJECT_STATUS = {}));
//# sourceMappingURL=models.js.map